import { Form } from '@vivaldis/antd-ui'
import type { EmployeeInput } from '@vivaldis/graphql'
import { Step, useStep } from '../../provider/StepProvider'
import { FormContent } from './components/FormContent'
import { FormProvider } from './provider/FormProvider'
import { ActionBar } from './components/ActionBar'

interface Props {
  onEmployeeUpdate: (employeeInput: EmployeeInput) => Promise<void>
}

export const AddWorkPermitStep = ({ onEmployeeUpdate }: Props) => {
  const { step } = useStep()

  if (step !== Step.AddWorkPermitStep) {
    return null
  }

  return (
    <FormProvider onEmployeeUpdate={onEmployeeUpdate}>
      <Form autoComplete="off">
        <FormContent />
        <ActionBar />
      </Form>
    </FormProvider>
  )
}
